module.exports = __webpack_public_path__ + "assets/img/lietuvos-zemelapis-sviesos-intensyvumas.1acfd333.jpg";